<div class="container">
  <div class="row firstRowContent">
    <legend>Settlement Detail for Batch {{ batchInfo?.number + ": " + (batchInfo?.startDateUtc | date:'MM/dd/yyyy') + " - " + (batchInfo?.endDateUtc | date:'MM/dd/yyyy') }}</legend>
    <div class="divTableZero">
      <div *ngIf="trips.length > 0">
        <button
          class="btn"
          style="background: lightgrey; margin-bottom: 6px"
          (click)="excelGeneration()"
        >
          GENERATE EXCEL
        </button>
      </div>
      <p-table
        #dt
        [columns]="cols"
        [value]="trips"
        dataKey="tripNo"
        sortMode="multiple"
        scrollHeight="flex"

        [expandedRowKeys]="trips"
      >
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">No records found</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="colgroup" let-columns>
          <colgroup>
            <col *ngFor="let col of columns" [style.width.px]="col.width || 180" />
          </colgroup>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [title]="col.header">
              {{ col.header }}
              <p-sortIcon *ngIf="col.header.length" [field]="col.field"></p-sortIcon>
            </th>
          </tr>
          <tr>
            <th *ngFor="let col of columns" [ngSwitch]="col.field">
              <input
                *ngIf="isFilterable(col.field)"
                type="text"
                style="width: 100%"
                (input)="$any(dt).filter($event.target.value, col.field, 'contains')"
                [value]="$any(dt).filters[col.field]?.value"
              />
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-trip let-expanded="expanded">
          <tr class="clickable-row" style="height: 22px">
            <td
              *ngFor="let col of cols"
              [ngStyle]="{
                'text-align': col.type === 'number' || col.type === 'currency' ? 'right' : 'left'
              }"
            >
              <span *ngIf="!col.type">{{ trip[col.field] }}</span>
              <span *ngIf="col.type === 'boolean'">{{ trip[col.field] | yesNo }}</span>
              <span *ngIf="col.type === 'date'">
                {{ trip[col.field] | date : "MM/dd/yy HH:mm"}}
              </span>
              <span *ngIf="col.type === 'number'">
                {{ trip[col.field] | number : "1.0" : "en-US" }}
              </span>
              <span *ngIf="col.type === 'currency'">{{ trip[col.field] | currency }}</span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
